var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.2C14.2091 23.2 16 21.4091 16 19.2C16 16.9908 14.2091 15.2 12 15.2C9.79086 15.2 8 16.9908 8 19.2C8 21.4091 9.79086 23.2 12 23.2Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4399 19.3001L11.0899 19.9501C11.2799 20.1401 11.5899 20.1401 11.7799 19.9601L13.5599 18.3201",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 27H16.0001C20.0201 27 20.7401 25.39 20.9501 23.43L21.7001 15.43C21.9701 12.99 21.2701 11 17.0001 11H7.00007C2.73007 11 2.03007 12.99 2.30007 15.43L3.05007 23.43C3.26007 25.39 3.98007 27 8.00007 27Z",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11V10.2C8 8.43 8 7 11.2 7H12.8C16 7 16 8.43 16 10.2V11",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 16C19.92 17.26 18 18.14 16.01 18.64",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62012 16.27C4.29012 17.41 6.11012 18.22 8.00012 18.68",
    stroke: "#07224D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryIcon);
export default __webpack_public_path__ + "static/media/industry-icon.95d7797f1bd3965a71297a0b0d32e0bd.svg";
export { ForwardRef as ReactComponent };